import { gql } from '@apollo/client';

export const GET_SURVEYS = gql(/* GraphQL */ `
    query GetSurveys($filter: SurveyFilterInput) {
        getSurveys(filter: $filter) {
            surveys {
                id
                advertisingZoneId
                advertisingZone {
                    id
                    name
                    stores {
                        id
                        name
                        storeNo
                    }
                }
                storeId
                store {
                    id
                    name
                    storeNo
                }
                dueBy
                status
                completedAt
                championUserId
                championUser {
                    id
                    firstName
                    lastName
                    managerStore {
                        id
                        name
                        storeNo
                    }
                }
                createdByUserId
                createdByUser {
                    id
                    firstName
                    lastName
                }
                surveyCompetitors {
                    id
                    competitorId
                    competitor {
                        id
                        name
                    }
                }
                totalItemsCount
                completedItemsCount
                priceChangeRequestsCount
                dmActionedItemsCount
                dmActionableItemsCount
                surveyType
                label
                createdAt
                updatedAt
            }
            pagination {
                limit
                offset
                total
            }
        }
    }
`);

export const GET_SURVEY = gql(/* GraphQL */ `
    query GetSurvey($id: String!) {
        getSurvey(id: $id) {
            id
            advertisingZoneId
            advertisingZone {
                id
                name
                stores {
                    id
                    name
                    storeNo
                    isTradingAsCashbuild
                    isClosed
                }
            }
            storeId
            store {
                id
                name
                storeNo
            }
            dueBy
            status
            completedAt
            championUserId
            championUser {
                id
                firstName
                lastName
                managerStore {
                    id
                    name
                    storeNo
                }
            }
            createdByUserId
            createdByUser {
                id
                firstName
                lastName
            }
            isSystemGenerated
            surveyType
            label
            surveyItems {
                id
                rank
                productId
                product {
                    id
                    sku
                    description
                    currentSellingPrice
                    sellingPriceCurrency
                    sellingPriceValidFrom
                    sellingPriceValidTo
                    currentCostPrice
                    costPriceCurrency
                }
                categoryId
                category {
                    id
                    name
                    benchmarkMargin
                }
                suggestedPrice
                resolvedVatPercentage
                zoneHighestCostPrice
                cashbuildCostPrice
                pnlCostPrice
                currentCashbuildPrice
                currentPnlPrice
                proposedSellingPrice
                notes
                isDeclinedForPriceChange
                declinedReason
                approvedForPriceChange
                priceChangeRequestId
                priceChangeRequest {
                    id
                    friendlyId
                    proposedPrice
                    createdAt
                    completedAt
                    latestStatus
                }
                surveyItemPrices {
                    id
                    price
                    isNA
                    priceSurveyCompetitorId
                    notes
                    recordedAt
                }
            }
            surveyCompetitors {
                id
                competitorId
                competitor {
                    id
                    storeId
                    advertisingZoneId
                    name
                    email
                    address
                    isMajor
                    telNo {
                        countryCode
                        dialingCode
                        number
                    }
                }
                proofOfSurveyCompetitorPricing {
                    id
                }
            }
            createdAt
            updatedAt
            totalItemsCount
            completedItemsCount
            dmActionedItemsCount
            dmActionableItemsCount
        }
    }
`);

export const GET_SURVEY_HISTORY_DRAWER = gql(/* GraphQL */ `
    query GetSurveyHistoryDrawer($id: String!) {
        getSurvey(id: $id) {
            id
            advertisingZone {
                name
                stores {
                    id
                    storeNo
                    name
                }
            }
            storeId
            store {
                id
                name
                storeNo
            }
            championUser {
                managerStore {
                    id
                }
            }
            createdAt
            dueBy
            surveyItems {
                id
                priceChangeRequestId
                priceChangeRequest {
                    id
                    friendlyId
                    createdAt
                    latestStatus
                }
            }
        }
    }
`);

export const GET_SURVEY_COUNTS = gql(/* GraphQL */ `
    query GetSurveyCounts($filter: SurveyCountsFilterInput) {
        getSurveyCounts(filter: $filter) {
            active
            inProgress
            completed
            overdue
            notStarted
            priceChangesGenerated
        }
    }
`);

export const GET_SURVEY_PRODUCT_LISTS = gql(/* GraphQL */ `
    query GetSurveyProductLists($input: GetSurveyProductListsInput!) {
        getSurveyProductLists(input: $input) {
            lists {
                manualDataImportLogId
                label
                surveyType
                productCount
                uploadedAt
            }
        }
    }
`);

export const GET_SURVEY_PRODUCTS_BY_IMPORT_LOG = gql(/* GraphQL */ `
    query GetSurveyProductsByImportLog(
        $input: GetSurveyProductsByImportLogInput!
    ) {
        getSurveyProductsByImportLog(input: $input) {
            manualDataImportLogId
            label
            surveyType
            products {
                id
                surveyProductListId
                advertisingZoneId
                rank
                sku
                createdAt
                updatedAt
            }
        }
    }
`);

export const GET_PROOF_OF_SURVEY_COMPETITOR_PRICING = gql(/* GraphQL */ `
    query GetProofOfSurveyCompetitorPricing($priceSurveyCompetitorId: String!) {
        getProofOfSurveyCompetitorPricing(
            priceSurveyCompetitorId: $priceSurveyCompetitorId
        ) {
            id
            priceSurveyCompetitorId
            fileName
            fileSize
            fileType
            downloadUrl
            documentS3Path
            createdAt
        }
    }
`);
